/**
 * Scroll Reveal Component
 *
 * Any descendant content will be hidden until the bottom is reached, then the content will be revealed.
 */
export class GMXScrollReveal extends HTMLElement {
	intersectionObserver: IntersectionObserver

	private boundHandleObservationCallback = this._handleObservation.bind(this)

	connectedCallback(): void {
		this.intersectionObserver = new IntersectionObserver(this.boundHandleObservationCallback, {
			root: null,
			rootMargin: '0px',
			threshold: 1,
		})
		this.intersectionObserver.observe(this)
	}

	disconnectedCallback(): void {
		if (this.intersectionObserver) {
			this.intersectionObserver.unobserve(this)
		}
	}

	/**
	 * Callback for when the IntersectionObserver triggers an observation event
	 * @param entries
	 * @private
	 */
	private _handleObservation(entries: IntersectionObserverEntry[]): void {
		entries.forEach(entry => {
			this.showOrHide(entry.isIntersecting)
		})
	}

	showOrHide(isIntersecting: boolean): void {
		if (isIntersecting) {
			this.setAttribute('data-reveal', '')
		} else {
			const overlayClientRect = this.getBoundingClientRect()
			if (overlayClientRect.bottom > overlayClientRect.height) {
				this.removeAttribute('data-reveal')
			} else {
				this.setAttribute('data-reveal', '')
			}
		}
	}
}

if (!customElements.get('gmx-scroll-reveal')) {
	customElements.define('gmx-scroll-reveal', GMXScrollReveal)
}
